<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="chargePolicies"
      :items="chargePolicies"
      :fields="chargePoliciesFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <b-modal ref="modalChargePolicies" id="modalChargePolicies" hide-footer :title="$t('Charge policies')" size="lg">
      <editModal
      :currentRowChargePolicies="currentRowChargePolicies"
      :isTariffication="isTariffication"
      @hideModalChargePolicies="hideModalChargePolicies"/>
    </b-modal>
  </div>
</template>

<script>
import editModal from './editModal'
export default {
  components: {
    editModal
  },
  data () {
    return {
      isTariffication: true,
      chargePoliciesFields: [
        {key: 'policy_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      currentRowChargePolicies: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    hideModalChargePolicies () {
      this.$refs.modalChargePolicies.hide()
    },
    showAdd () {
      this.currentRowChargePolicies = {
        policy_id: 0,
        name: '',
        flags: 0,
        blockchecktimemarks: []
      }
      this.$root.$emit('bv::show::modal', 'modalChargePolicies', '#btnShow')
    },
    editItem (item) {
      this.currentRowChargePolicies = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalChargePolicies', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Charge policies"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Tariffing/DELETE_CHARGE_POLICIES', item.policy_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_CHARGE_POLICIES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    chargePolicies () {
      return this.$store.getters['Tariffing/CHARGE_POLICIES']
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_CHARGE_POLICIES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/additional/chargePolicies/main.vue